/* RVA Threads flow2 notes (Oct 15 2026, J: "this can be one note i think").
   When the youth note (rva-cat-yv.js) and the women's note (rva-cat-wm.js) would both show in the same spot
   (request page, request drawer, the "Added to your request" drop-down, the catalog grid), show one note instead,
   worded like the catalog's brand-filter note (rva-cat-facets.js "wy"). The youth note carries the combined text
   and the women's note is hidden; each goes back to normal as soon as only one of them applies. */
(function(){
"use strict";
var HTML="<strong>Ordering women's or youth sizes too?</strong> Women's and youth shirts are cut smaller, so the design is resized to fit them and each is treated as a separate order, priced on its own quantity.",
PAIRS=[["ythReqNote","wmReqNote"],["ythDrawNote","wmDrawNote"],["ythToastNote","wmToastNote"],["ythGridNote","wmGridNote"],["ythPanelNote","wmPanelNote"]];
function fix(){
PAIRS.forEach(function(p){
var y=document.getElementById(p[0]),w=document.getElementById(p[1]),
both=!!(y&&w&&y.isConnected&&w.isConnected&&y.parentNode===w.parentNode);
if(y){
if(both&&!y.__rvaM){y.__rvaO=y.innerHTML;y.innerHTML=HTML;y.__rvaM=1}
else if(!both&&y.__rvaM){y.innerHTML=y.__rvaO;y.__rvaM=0}
}
if(w){
if(both&&!w.__rvaH){w.style.setProperty("display","none","important");w.__rvaH=1}
else if(!both&&w.__rvaH){w.style.removeProperty("display");w.__rvaH=0}
}
});
}
function has(n){return n.nodeType===1&&(/(?:^|\s)(?:ythNote|wmNote)(?:\s|$)/.test(n.className)||!!n.querySelector(".ythNote,.wmNote"))}
function boot(){
new MutationObserver(function(recs){
for(var i=0;i<recs.length;i++){
var a=recs[i].addedNodes,r=recs[i].removedNodes,j;
for(j=0;j<a.length;j++)if(has(a[j])){fix();return}
for(j=0;j<r.length;j++)if(has(r[j])){fix();return}
}
}).observe(document.body,{childList:true,subtree:true});
fix();
}
if(document.body)boot();else document.addEventListener("DOMContentLoaded",boot);
})();